export const EVENTS = {
  PAGE_LOADED: 'movement:page:loaded',
  ACTION_CHANGED: 'movement:action:changed',
  EMAIL_TO_TARGET_STEP_CHANGE: 'movement:email_to_target:step_change',
}

// Legacy event names for backwards compatibility
const LEGACY_EVENTS = {
  [EVENTS.PAGE_LOADED]: 'movementPageLoaded',
  [EVENTS.ACTION_CHANGED]: 'movementActionChanged',
}

export function firePageEvent(name, detail, element = document) {
  element.dispatchEvent(new CustomEvent(name, {
    detail,
    bubbles: true,
  }))

  // Fire legacy event name for backwards compatibility
  if (LEGACY_EVENTS[name]) {
    element.dispatchEvent(new CustomEvent(LEGACY_EVENTS[name], {
      detail,
      bubbles: true,
    }))
  }
}
